<div class="search-bar d-flex align-items-center">
    <div class="search-bar__prefix d-flex align-items-center flex-grow-1">
        <div class="search-bar__count h5 no-wrap">
            @if (definition.isLocked) {
                <wdx-icon
                    class="text-muted me-1"
                    icon="lock"
                    iconStyle="fas"
                ></wdx-icon>
            }
            <span class="fw-normal">
                {{ definition?.label | translateTokenisedString }}
            </span>
            <span
                [attr.data-cy]="'quantity-amount-' + definition?.name"
                [attr.data-cy-value]="amount"
                >({{ amount }})</span
            >
        </div>

        @if (showValidation) {
            <wdx-icon
                [attr.data-cy]="
                    'sub-form-header-validation-' + definition?.name
                "
                class="text-danger ms-2"
                icon="exclamation-triangle"
                [scale]="1"
            ></wdx-icon>
        }

        @if (showValidation && validationErrorMessage) {
            <div
                [attr.data-cy]="'validation-error-message-' + definition?.name"
                class="ms-2 text-danger small"
            >
                {{ validationErrorMessage }}
            </div>
        }
    </div>

    @if (
        !disabled &&
        !readonlyMode &&
        definition?.arrayConfiguration?.allowAdd !== false
    ) {
        <div class="d-flex align-items-center position-relative flex-shrink-0">
            <div class="search-bar__search-input"></div>
            <wdx-icon-button
                [attr.data-cy]="'btn-add-' + definition?.name"
                wdxStyle="outline-primary"
                wdxButton
                [size]="'sm'"
                (wdxOnClick)="onAddToArrayClicked()"
            >
                <wdx-icon [icon]="addIcon"></wdx-icon>
            </wdx-icon-button>
        </div>
    }
</div>
